import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { XCircle } from 'lucide-react';
const approaches = [{
  title: 'Dietas extremas',
  description: 'Las dietas extremas de "pasar hambre" solo elevan más tu cortisol, haciendo que tu cuerpo se hinche por puro instinto de supervivencia.'
}, {
  title: 'Jugos comerciales',
  description: 'Los jugos verdes comerciales de supermercado están llenos de azúcares ocultos que disparan tu insulina y bloquean la quema de grasa.'
}, {
  title: 'Cardio excesivo',
  description: 'El ejercicio intenso sin recuperación adecuada inflama tus articulaciones y te deja más agotado que al empezar.'
}, {
  title: 'Suplementos mágicos',
  description: 'Los suplementos "detox" suelen ser laxantes agresivos que irritan tu colon y no eliminan la inflamación celular real.'
}];
export function FailedApproaches() {
  return <SectionWrapper className="bg-white" data-id="element-13">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-16">
            Por qué lo que has intentado no funciona
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-17">
            La industria te ha vendido soluciones que en realidad empeoran el
            problema.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-18">
          {approaches.map((item, index) => <div key={index} className="bg-gray-50 rounded-2xl p-8 flex items-start gap-5 hover:shadow-md transition-shadow duration-300 border border-gray-100" data-id="element-19">
              <XCircle className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-20" />
              <div data-id="element-21">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-22">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-23">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}